import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { Map, Marker, GoogleApiWrapper as GoogleMap } from 'google-maps-react';
import { canUseDOM, get, hexToRgb } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
// import Location from '../../resources/icons/Location.svg';

export var defaultMapState = {
  lat: 25.2048493,
  lng: 55.2707828,
  activeMarker: 0,
  markers: [{}]
};
export var googleMapDirectionLink = function googleMapDirectionLink(lat, lng) {
  return "https://www.google.com/maps/dir/?api=1&destination=".concat(lat, ",").concat(lng);
};
var defaultMarker = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNC4xNjEiIGhlaWdodD0iNDMuMDY0IiB2aWV3Qm94PSIwIDAgMzQuMTYxIDQzLjA2NCI+DQogIDxnIGlkPSJub3VuX0xvY2F0aW9uXzMwMjAzNzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03Ni43NTggLTE5NC40NTgpIj4NCiAgICA8ZyBpZD0iRWxsaXBzZV8xMDMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDg2Ljc1OCAyMDMuOTYxKSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNzA3MDcwIiBzdHJva2Utd2lkdGg9IjEiPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iNy41IiBjeT0iNy41IiByPSI3IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIGlkPSJHcm91cF81NyIgZGF0YS1uYW1lPSJHcm91cCA1NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzYuNzU4IDE5NC40NTYpIj4NCiAgICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8xIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDEiIGQ9Ik0tNjQ0NC43OTItMTkwMi40M2ExLjYsMS42LDAsMCwxLTEuMTM4LS40NzEsOTcuMzcsOTcuMzcsMCwwLDEtMTAuNzEzLTEyLjMzM2MtMy40ODEtNS4wMzctNS4yMzMtOS42MjQtNS4zNTYtMTQuMDIxdi0uMDg0YTE2LjYxOSwxNi42MTksMCwwLDEsNC45NzgtMTEuMjkyLDE3LjEzOSwxNy4xMzksMCwwLDEsMTEuNzU3LTQuODYxYy4xMTgsMCwuMjM2LDAsLjM1NCwwYTE3LjUsMTcuNSwwLDAsMSwxMS44OTQsNC41NjcsMTUuNzQyLDE1Ljc0MiwwLDAsMSw1LjE3NiwxMS4ydi4wMWMuMDY5LDQuMzM0LTEuMjkyLDguNjE3LTQuMTYzLDEzLjA5M2E3OS40NzIsNzkuNDcyLDAsMCwxLTkuMDQ5LDEwLjkyNmwtLjA0NC4wNDdjLS44NzIuOTM0LTEuNjk1LDEuODE2LTIuNTA1LDIuNzA5YTEuNTkyLDEuNTkyLDAsMCwxLTEuMTUzLjUxMlptLjI5Mi0zMS41NjFhNC41LDQuNSwwLDAsMC00LjUsNC41LDQuNTA1LDQuNTA1LDAsMCwwLDQuNSw0LjUsNC41MDYsNC41MDYsMCwwLDAsNC41LTQuNUE0LjUsNC41LDAsMCwwLTY0NDQuNS0xOTMzLjk5MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY0NjIgMTk0NS40OTcpIiBmaWxsPSIjMDA2N2I5Ii8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==';
var MapContainer = /*#__PURE__*/function (_React$Component) {
  function MapContainer(props) {
    var _this;
    _classCallCheck(this, MapContainer);
    _this = _callSuper(this, MapContainer, [props]);
    _defineProperty(_this, "primary", void 0);
    _defineProperty(_this, "primary_active", void 0);
    _defineProperty(_this, "activeMarker", -1);
    _defineProperty(_this, "mapRef", void 0);
    _defineProperty(_this, "setBound", function () {
      var mapState = _this.props.mapState;
      if (_this.props.google) {
        if (mapState.markers[0].lat && mapState.markers[0].lng) {
          var bounds = new _this.props.google.maps.LatLngBounds();
          mapState.markers.some(function (marker) {
            var lat = Number(marker.lat);
            var lng = Number(marker.lng);
            if (marker.centered) {
              bounds = new _this.props.google.maps.LatLngBounds();
              bounds.extend({
                lat: lat,
                lng: lng
              });
            } else bounds.extend({
              lat: lat,
              lng: lng
            });
            return marker.centered;
          });
          return bounds;
        }
      }
    });
    _defineProperty(_this, "onMouseOverMarker", function (index, markerProps, marker, _ref) {
      var domEvent = _ref.domEvent;
      var toggleColor = function toggleColor() {
        if (_this.primary !== _this.primary_active) {
          if (~icon.url.indexOf(_this.primary)) {
            icon.url = icon.url.replace(_this.primary, _this.primary_active);
            marker.setIcon(icon);
          } else {
            icon.url = icon.url.replace(_this.primary_active, _this.primary);
            marker.setIcon(icon);
          }
        }
      };
      if (_this.state.activeMarker === index) {
        return;
      } else if (_this.state.activeMarker === -1 && index === 0) {
        return;
      }
      var icon = marker.getIcon();
      if (domEvent.type === 'mouseover') {
        toggleColor();
        marker.setZIndex(30);
      } else if (domEvent.type === 'mouseout') {
        toggleColor();
        marker.setZIndex(index);
      }
    });
    _defineProperty(_this, "onMarkerCallback", function (index, maps, marker) {
      var analytics = _this.props.analytics;
      var map = maps.map;
      var _map$center = map.center,
        lng = _map$center.lng,
        lat = _map$center.lat;
      var center = {
        lng: lng(),
        lat: lat()
      };
      var center2 = {
        lng: marker.position.lng(),
        lat: marker.position.lat()
      };
      _this.props.isCenterOnMarkerClick && map.panTo(center2);
      _this.activeMarker = index;
      _this.props.markerCallback && _this.props.markerCallback(marker, _this.props.isCenterOnMarkerClick ? center2 : center, true);
      _this.setState({
        activeMarker: index,
        center: _this.props.isCenterOnMarkerClick ? center2 : center
      });
      if (analytics) {
        tealiumClickFunc(tealiumMergeClickData(analytics['analytics'], analytics['params']), analytics['text']);
      }
    });
    _defineProperty(_this, "mapReadyHandler", function () {
      var callback = _this.props.callback;
      callback();
      setTimeout(function () {
        var current = _this.mapRef.current && _this.mapRef.current;
        if (current) {
          var block = current.mapRef.current.querySelector('[role="region"]');
          if (block) {
            block.removeAttribute("aria-roledescription");
          }
        }
      }, 300);
    });
    _this.state = {
      activeMarker: -1,
      maxZoom: 0
    };
    _this.mapRef = /*#__PURE__*/React.createRef();
    var primary = get(_this.props.theme, 'primary', '');
    var primary_active = get(_this.props.theme, 'primary_active', '');
    var style = {};
    if (typeof window !== 'undefined') {
      style = window.getComputedStyle(document.querySelector('html'));
    }
    if (~primary.indexOf('--')) {
      primary = style.getPropertyValue(primary);
    }
    if (~primary_active.indexOf('--')) {
      primary_active = style.getPropertyValue(primary_active);
    }
    if (canUseDOM && document.body.classList.contains('vdsite')) {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    } else if (!document.body.classList.contains('vdsite')) {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(0 144 154)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(17 94 103)';
    } else {
      _this.primary = primary ? hexToRgb(primary) : 'rgb(82 82 82)';
      _this.primary_active = primary_active ? hexToRgb(primary_active) : 'rgb(0 103 185)';
    }
    return _this;
  }
  _inherits(MapContainer, _React$Component);
  return _createClass(MapContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var current = this.mapRef.current && this.mapRef.current;
      // @ts-ignore
      var map = current.map;
      if (map && this.props.maxZoomActive) {
        var listener = google.maps.event.addListener(map, "idle", function () {
          _this2.setState({
            maxZoom: map.getZoom() + _this2.props.zoomedLevel
          });
          map.setOptions({
            maxZoom: map.getZoom() + _this2.props.zoomedLevel
          });
          google.maps.event.removeListener(listener);
        });
      }
    }
    // componentDidUpdate () {
    //   const current = this.mapRef.current && this.mapRef.current
    //   // @ts-ignore
    //   const map = current.map
    //   if(map && this.props.maxZoomActive) {
    //      const listener = google.maps.event.addListener(map, "idle", () => {
    //         const maxZoom = this.state.maxZoom || 0
    //         if(maxZoom !=0 && map.getZoom() > maxZoom )
    //           map.setZoom(this.state.maxZoom)
    //
    //         google.maps.event.removeListener(listener);
    //       });
    //
    //
    //   }
    //
    // }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var mapState = this.props.mapState;
      if (nextState.activeMarker == this.state.activeMarker && mapState === nextProps.mapState) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var mapState = _ref2.mapState;
      if (mapState.activeMarker !== this.state.activeMarker) {
        this.setState({
          activeMarker: mapState.activeMarker
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        zoom = _this$props.zoom,
        google = _this$props.google,
        mapState = _this$props.mapState,
        customMarker = _this$props.customMarker,
        disableBound = _this$props.disableBound,
        _this$props$allowZoom = _this$props.allowZoomControl,
        allowZoomControl = _this$props$allowZoom === void 0 ? true : _this$props$allowZoom,
        zoomChanged = _this$props.zoomChanged,
        _this$props$visible = _this$props.visible,
        visible = _this$props$visible === void 0 ? true : _this$props$visible;
      var options;
      var center = {};
      if (mapState.markers.length < 2 || disableBound) {
        options = {
          zoom: zoom,
          center: {
            lat: mapState.lat,
            lng: mapState.lng
          }
        };
        center = options.center;
      } else {
        var bounds = this.setBound();
        options = {
          bounds: bounds
        };
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Map, _extends({
        ref: this.mapRef,
        google: google
      }, options, {
        visible: visible,
        onReady: this.mapReadyHandler,
        center: center,
        streetViewControl: false,
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: allowZoomControl,
        onZoomChanged: zoomChanged,
        fullscreenControl: false,
        keyboardShortcuts: false,
        initialCenter: {
          lat: mapState.lat,
          lng: mapState.lng
        }
      }), google && mapState.markers && mapState.markers.map(function (marker, index) {
        var lat = Number(marker.lat);
        var lng = Number(marker.lng);
        return /*#__PURE__*/React.createElement(Marker, {
          key: index,
          label: customMarker && mapState.markers.length > 1 ? {
            text: "".concat(index + 1),
            color: '#fff',
            fontSize: '12px'
          } : '',
          title: marker.title,
          icon: customMarker && mapState.markers.length > 1 ? {
            url: "data:image/svg+xml;utf-8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"33.704\" viewBox=\"0 0 23 33.704\">\n                            <path id=\"Union_62\" data-name=\"Union 62\" d=\"M925.616,18.65a11.5,11.5,0,1,1,18.909-.2L935.485,34.2Z\" transform=\"translate(-923.5 -0.5)\" fill=\"".concat(mapState.activeMarker === index || _this3.state.activeMarker == index ? _this3.primary_active : _this3.primary, "\"/>\n                          </svg>"),
            //  anchor: new google.maps.Point(41, 60),
            scaledSize: new google.maps.Size(34, 43),
            labelOrigin: new google.maps.Point(17, 17)
          } : {
            url: "data:image/svg+xml;utf-8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"34.161\" height=\"43.064\" viewBox=\"0 0 34.161 43.064\">\n                            <g id=\"Group_57\" data-name=\"Group 57\" transform=\"translate(0, 0)\">\n                              <path id=\"Subtraction_1\" data-name=\"Subtraction 1\" d=\"M-6444.792-1902.43a1.6,1.6,0,0,1-1.138-.471,97.37,97.37,0,0,1-10.713-12.333c-3.481-5.037-5.233-9.624-5.356-14.021v-.084a16.619,16.619,0,0,1,4.978-11.292,17.139,17.139,0,0,1,11.757-4.861c.118,0,.236,0,.354,0a17.5,17.5,0,0,1,11.894,4.567,15.742,15.742,0,0,1,5.176,11.2v.01c.069,4.334-1.292,8.617-4.163,13.093a79.472,79.472,0,0,1-9.049,10.926l-.044.047c-.872.934-1.695,1.816-2.505,2.709a1.592,1.592,0,0,1-1.153.512Zm.292-31.561a4.5,4.5,0,0,0-4.5,4.5,4.505,4.505,0,0,0,4.5,4.5,4.506,4.506,0,0,0,4.5-4.5A4.5,4.5,0,0,0-6444.5-1933.991Z\" transform=\"translate(6462 1945.497)\" fill=\"".concat(_this3.state.activeMarker === -1 && mapState.activeMarker === index || _this3.state.activeMarker === index ? _this3.primary_active : _this3.primary, "\" />\n                          </g>\n                        </svg>"),
            //  anchor: new google.maps.Point(34, 43),
            scaledSize: new google.maps.Size(34, 43)
          },
          onMouseout: _this3.onMouseOverMarker.bind(_this3, index),
          onClick: _this3.onMarkerCallback.bind(_this3, index),
          onMouseover: _this3.onMouseOverMarker.bind(_this3, index),
          position: {
            lat: lat,
            lng: lng
          },
          zIndex: index >= 0 && mapState.activeMarker === index || _this3.state.activeMarker == index ? mapState.markers.length + 1 : index
        });
      })));
    }
  }]);
}(React.Component);
export default GoogleMap({
  apiKey: !process.env.STORYBOOK_MODE && canUseDOM ? get(window, 'map_key') : 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8',
  language: !process.env.STORYBOOK_MODE && canUseDOM ? get(window, 'current_language') : 'en'
})(MapContainer);